import { IconProps } from 'components'
import { ComponentProps } from 'react'
import { theme } from 'styles/theme/hav-theme'

export const EDI = ({
  color = theme.colors.neutral.light,
  fill = theme.colors.neutral.white,
  width = '28',
  height = '18',
  viewBox = '0 0 28 18',
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="27" height="17" rx="1.5" stroke={color} />
      <path
        d="M4.84 13.5V4.86H10.48V6.384H6.472V8.232H9.76V9.756H6.472V11.976H10.48V13.5H4.84ZM11.9181 13.5V4.86H14.7141C14.7821 4.86 14.9221 4.862 15.1341 4.866C15.3461 4.87 15.5501 4.884 15.7461 4.908C16.4421 4.992 17.0321 5.234 17.5161 5.634C18.0001 6.034 18.3681 6.542 18.6201 7.158C18.8721 7.774 18.9981 8.448 18.9981 9.18C18.9981 9.912 18.8721 10.586 18.6201 11.202C18.3681 11.818 18.0001 12.326 17.5161 12.726C17.0321 13.126 16.4421 13.368 15.7461 13.452C15.5501 13.476 15.3461 13.49 15.1341 13.494C14.9221 13.498 14.7821 13.5 14.7141 13.5H11.9181ZM13.5741 11.964H14.7141C14.8221 11.964 14.9681 11.962 15.1521 11.958C15.3361 11.95 15.5021 11.932 15.6501 11.904C16.0261 11.828 16.3321 11.652 16.5681 11.376C16.8081 11.1 16.9841 10.768 17.0961 10.38C17.2121 9.992 17.2701 9.592 17.2701 9.18C17.2701 8.748 17.2101 8.338 17.0901 7.95C16.9741 7.562 16.7961 7.234 16.5561 6.966C16.3161 6.698 16.0141 6.528 15.6501 6.456C15.5021 6.424 15.3361 6.406 15.1521 6.402C14.9681 6.398 14.8221 6.396 14.7141 6.396H13.5741V11.964ZM20.5577 13.5V4.86H22.1897V13.5H20.5577Z"
        fill={color}
      />
    </svg>
  )
}
